import { useEffect } from 'react';
import { MobileSetPassword } from './mobile';
import { DesktopSetPassword } from './desktop';
import { useRouter } from 'common/hooks/useRouter';
import { UseIsMobile } from 'common/hooks/UseIsMobile';

function SetPassword() {
  const {
    navigate,
    history: { state },
  } = useRouter();
  const mobile = UseIsMobile()

  useEffect(() => {
    if (!state?.flow) {
      navigate.push('/change-password/otp');
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {
        mobile ?
          <div className="md:hidden">
            <MobileSetPassword />
          </div>
          :
          <div className="hidden md:block">
            <DesktopSetPassword />
          </div>
      }
    </div>
  );
}

export default SetPassword;
